var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.726,
    height: 15.921,
    viewBox: "0 0 26.726 15.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "right-arrow_1_",
    "data-name": "right-arrow (1)",
    d: "M15.167,11.561,4.36.754A2.55,2.55,0,0,0,.741,4.348L9.764,13.37.741,22.393A2.55,2.55,0,0,0,4.36,25.987L15.167,15.18a2.549,2.549,0,0,0,0-3.619Z",
    transform: "translate(26.726) rotate(90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow1);
export default __webpack_public_path__ + "static/media/right-arrow (1).e99ef9cdbeaf2f172aa6b5af2f24dbd8.svg";
export { ForwardRef as ReactComponent };